import React from "react";

const Confetti = React.memo(({ index }) => (
  <div
    key={index}
    className="confetti"
    style={{
      left: `${Math.random() * 100}%`,
      animationDelay: `${Math.random() * 4}s`,
    }}
  ></div>
));

export default Confetti;
